import { useIsMobile } from 'src/common/hooks/useIsMobile';

/**
 * Text colours for the onboarding hero screens.
 *
 * `AuthPageLayout` renders a near-white background on mobile (`gray.0`, #F9F9F9) and a
 * near-black one on desktop (`gray.10`, #1A1A1A), so any fixed colour is unreadable on
 * one of them - a `gray.0` title on mobile is 1:1 against its own background. These
 * invert with the layout and keep every pairing at or above WCAG AA for its text size.
 */
export function useHeroTextColours() {
  const { isMobile } = useIsMobile();

  return isMobile
    ? { title: 'gray.10', subtitle: 'gray.7', body: 'gray.7', accent: 'brand.8' }
    : { title: 'gray.0', subtitle: 'gray.4', body: 'gray.5', accent: 'brand.4' };
}
